import type React from "react";
import "./MainHeader.css";
import { Avatar, Menu, MenuItem, NavBar } from "@sede-enterprise/shell-ds-react-framework";
import { Link } from "react-router-dom";
import { HELP_LABEL, HELP_LINK } from "../../api/constants";
import {
  ALL_CARBON_DEALS_HEADING,
  LOGOUT,
  SUB_TITLE_KPI_CALCULATOR,
  TABS_MENU,
  TITLE_KPI_CALCULATOR,
} from "../../constants";
import type { IMenuItem } from "../../types/types";
import CustomButton from "../CustomButton/CustomButton";
import { MainHeaderContainer } from "./MainHeader.styles";

interface MainHeaderProps {
  shortname: string;
  emailAddress: string;
  logout: () => void;
  isSuperUser: boolean;
}

const MainHeader: React.FC<MainHeaderProps> = ({
  shortname,
  emailAddress,
  logout,
  isSuperUser,
}) => {
  const itemRender = ({ path, children }: { path: string; children: React.ReactNode }) => (
    <Link to={path}>{children}</Link>
  );

  const tabsMenu = isSuperUser
    ? TABS_MENU
    : TABS_MENU.filter((tabMenu) => tabMenu.label !== ALL_CARBON_DEALS_HEADING); // Removing All deals tab if user doesn't have access

  const menuItems: IMenuItem[] = tabsMenu.map((item: IMenuItem) => ({
    label: item.label,
    key: item.key,
    path: item.path,
    children: item.children?.map((child: IMenuItem) => ({
      key: child.key,
      label: child.label,
      path: child.path,
    })),
  }));

  return (
    <MainHeaderContainer>
      <NavBar
        avatarArea={
          <>
            <CustomButton label={HELP_LABEL} link={HELP_LINK} />
            <Avatar
              label={emailAddress}
              title={shortname}
              dropdownOverlay={
                <Menu>
                  <MenuItem key="logout" onClick={logout}>
                    {LOGOUT}
                  </MenuItem>
                </Menu>
              }
            />
          </>
        }
        header={{ title: TITLE_KPI_CALCULATOR, description: SUB_TITLE_KPI_CALCULATOR }}
        items={menuItems}
        itemRender={itemRender}
        urlProps={{
          href: "https://www.shell.com",
        }}
      />
    </MainHeaderContainer>
  );
};

export default MainHeader;
